import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Ahorrar tiempo', 'Tener clases listas', 'Organizar el año completo', 'Enseñar con claridad', 'Reducir el estrés diario'];
  const scrollToOrder = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('order-bump')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 px-6 bg-gradient-to-b from-[#1a1a2e] to-[#0f0f23] relative overflow-hidden" data-id="element-221">
      <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-500/5 rounded-full blur-3xl" data-id="element-222" />

      <div className="relative z-10" data-id="element-223">
        <div className="text-center mb-8" data-id="element-224">
          <p className="text-yellow-400 font-bold mb-2 flex items-center justify-center gap-2" data-id="element-225">
            <Sparkles className="w-4 h-4" data-id="element-226" /> Por eso creamos:
          </p>
          <h2 className="text-3xl font-black text-white leading-tight mb-4" data-id="element-227">
            💥 EL MEGA KIT ANUAL DE MATEMÁTICA
          </h2>
          <p className="text-gray-300 text-sm" data-id="element-228">
            Un sistema completo pensado para docentes que necesitan:
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8" data-id="element-229">
          <div className="space-y-4" data-id="element-230">
            {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-3" data-id="element-231">
                <div className="bg-green-500/20 p-1 rounded-full" data-id="element-232">
                  <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-233" />
                </div>
                <span className="text-gray-200 font-medium" data-id="element-234">{benefit}</span>
              </div>)}
          </div>
        </div>

        <div className="text-center space-y-2 mb-8" data-id="element-235">
          <p className="text-gray-400 font-medium" data-id="element-236">👉 No es teoría.</p>
          <p className="text-gray-400 font-medium" data-id="element-237">
            👉 No es contenido suelto.
          </p>
          <p className="text-xl font-bold text-yellow-400 mt-4" data-id="element-238">
            Es un sistema listo para usar.
          </p>
        </div>

        <div className="flex justify-center cursor-pointer" onClick={scrollToOrder} data-id="element-239">
          <img src="https://cdn.magicpatterns.com/uploads/wAyp8CVFEGRkV95yVvho9A/ChatGPT_Image_14_abr_2026,_02_56_13_p.m.-Photoroom.png" alt="Mega Kit" className="w-4/5 object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-240" />
        </div>
      </div>
    </section>;
}